import { EMPTY_ARRAY } from "@regrello/core-utils";
import type {
  AcyclicFieldInstanceFields,
  FieldInstanceFields,
  FieldInstanceFieldsWithBaseValues,
} from "@regrello/graphql-api";

/**
 * Converts an acyclic field instance (i.e., no references to other field instances in the object)
 * as `FieldInstanceFields` with the missing fields stubbed.
 */
export function getFieldInstanceFieldsFromAcyclicFieldInstanceFields<
  T extends FieldInstanceFieldsWithBaseValues | AcyclicFieldInstanceFields,
>(fieldInstance: T): T & { values: FieldInstanceFields["values"] } {
  const newValuesArray: FieldInstanceFields["values"] = [];
  fieldInstance.values.forEach((value) => {
    switch (value.__typename) {
      case "FieldInstanceMultiValueParty":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceMultiValueParty: undefined,
          sinksFieldInstanceMultiValueParty: EMPTY_ARRAY,
          sourceFieldInstanceMultiValuePartyV2: undefined,
          tabularMultiValueParty: EMPTY_ARRAY,
          tabularAuxiliaryDataParty: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceMultiValueString":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceMultiValueString: undefined,
          sinksFieldInstanceMultiValueString: EMPTY_ARRAY,
          tabularMultiValueString: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueBoolean":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueBoolean: undefined,
          sinksFieldInstanceValueBoolean: EMPTY_ARRAY,
          tabularValueBoolean: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceMultiValueDocument":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceMultiValueDocument: undefined,
          sinksFieldInstanceMultiValueDocument: EMPTY_ARRAY,
          tabularAuxiliaryDataDocument: EMPTY_ARRAY,
          tabularMultiValueDocument: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueFloat":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueFloat: undefined,
          sinksFieldInstanceValueFloat: EMPTY_ARRAY,
          tabularValueFloat: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueInt":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueInt: undefined,
          sinksFieldInstanceValueInt: EMPTY_ARRAY,
          tabularValueInt: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueParty":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueParty: undefined,
          sinksFieldInstanceValueParty: EMPTY_ARRAY,
          tabularValueParty: EMPTY_ARRAY,
          tabularAuxiliaryDataParty: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueString":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueString: undefined,
          sinksFieldInstanceValueString: EMPTY_ARRAY,
          tabularValueString: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueTime":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueTime: undefined,
          sinksFieldInstanceValueTime: EMPTY_ARRAY,
          sourceFieldInstanceValueTimeV2: undefined,
          tabularValueTime: EMPTY_ARRAY,
        });
        break;
      case "FieldInstanceValueDate":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceValueDate: undefined,
          sinksFieldInstanceValueDate: EMPTY_ARRAY,
          sourceFieldInstanceValueDateV2: undefined,
        });
        break;
      case "FieldInstanceMultiValueRegrelloObjectInstance":
        newValuesArray.push({
          ...value,
          sourceFieldInstanceMultiValueRegrelloObjectInstance: undefined,
          sinksFieldInstanceMultiValueRegrelloObjectInstance: EMPTY_ARRAY,
          tabularAuxiliaryDataRegrelloObjectInstance: EMPTY_ARRAY,
          tabularMultiValueRegrelloObjectInstance: EMPTY_ARRAY,
        });
        break;
      default:
        break;
    }
  });
  const newFieldInstance = { ...fieldInstance, values: newValuesArray };
  return newFieldInstance;
}
